import {useContext, useMemo} from 'react'

import PropTypes from 'prop-types'

import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import CardBestOffer from '@adv-mt/mt-card-best-offer'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

const BASE_CLASS = 'mt-PanelBestOffers'

export default function PanelBestOffers({
  bestOffers: paramBestOffers,
  linkFactory: LinkFactory,
  showLogo = true,
  title
}) {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const logoSmallUrl = config.get('LOGO_SMALL_NEGATIVE_URL')

  const bestOffers = useMemo(
    () =>
      paramBestOffers.map(offer => {
        return (
          <div className={`${BASE_CLASS}-listItem`}>
            <CardBestOffer ad={offer} showMoreOffersLink linkFactory={LinkFactory} />
          </div>
        )
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [paramBestOffers]
  )
  return (
    <>
      <div className={`${BASE_CLASS}-header`}>
        {showLogo && (
          <div className={`${BASE_CLASS}-logo`}>
            <AtomImage src={logoSmallUrl} />
          </div>
        )}
        {title && <TitleBasic as={titleBasicTags.h2} size={titleBasicSizes.xs} title={title} />}
      </div>
      <section className={`${BASE_CLASS}-section`} id="panel-best-offers-id">
        <div className={`${BASE_CLASS}-list`}>{bestOffers}</div>
      </section>
    </>
  )
}

PanelBestOffers.displayName = 'PanelBestOffers'
PanelBestOffers.propTypes = {
  bestOffers: PropTypes.array.isRequired,
  linkFactory: PropTypes.func,
  showLogo: PropTypes.bool,
  title: PropTypes.string
}
